import { createUseStyles } from "react-jss";
import { colors } from "../../../styles/colors";

const useStyles = createUseStyles({
  divCompanyInformation: {
    display: "flex",
    flexDirection: "column",
    borderRadius: "15px",
    padding: "15px",
    gap: "15px",
    backgroundColor: colors.surface,
    border: `1px solid ${colors.borderLight}`,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  body: {
    display: "flex",
    flexDirection: "row",
    gap: "20px",
    alignItems: "center",
    "@media (max-width:599.95px)": {
      flexDirection: "column",
      alignItems: "flex-start",
    },
  },
  logoBox: {
    width: "88px",
    height: "88px",
    borderRadius: "12px",
    border: `1px solid ${colors.borderLight}`,
    backgroundColor: colors.surface,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
    flexShrink: 0,
  },
  logoImg: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  infos: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    flex: 1,
    minWidth: 0,
  },
});

export default useStyles;
